export default __webpack_public_path__ + "static/media/speedregister.8888f068.PNG";